import React from "react"
import PropTypes from "prop-types"
import { primitives } from '@lexody/design-tokens'

import Icon from '../app_components/Icon'

class DashMoreToDoSection extends React.Component {
  constructor(props) {
    super(props)

    this.renderBlogPosts = this.renderBlogPosts.bind(this)
    this.renderSuggestedBooks = this.renderSuggestedBooks.bind(this)
  }

  openBlogPost(blog) {
    window.open(`https://${blog.url}`, '_blank', 'noopener,noreferrer')
  }

  renderBlogPosts() {
    return (this.props.blogPosts || []).map((blog, index) => {
      return (
        <button
          key={blog.id || `${blog.created_at}-${index}`}
          type="button"
          className="dashboardBlogSection__card"
          onClick={() => this.openBlogPost(blog)}
          aria-label={`Read blog post: ${blog.title}`}
        >
          <div className="dashboardBlogSection__imageWrap">
            <img
              src={blog.image_url}
              alt=""
              className="dashboardBlogSection__image"
            />
          </div>
          <p className="dashboardBlogSection__cardTitle">{blog.title}</p>
        </button>
      )
    })
  }

  openBook(book) {
    window.location.assign(`/resources/${book.slug}`)
  }

  renderSuggestedBooks() {
    return (this.props.suggestedBooks || []).map((book, index) => {
      return (
        <button
          key={book.id || `${book.slug}-${index}`}
          type="button"
          className="dashboardReadingSection__card"
          onClick={() => this.openBook(book)}
          aria-label={`View book: ${book.title}`}
        >
          <div className="dashboardReadingSection__imageWrap">
            <img
              src={book.image_url}
              alt=""
              className="dashboardReadingSection__image"
            />
          </div>
          <p className="dashboardReadingSection__cardTitle">{book.title}</p>
          {book.language && (
            <p className="dashboardReadingSection__cardLanguage">{book.language}</p>
          )}
        </button>
      )
    })
  }

  renderReadingSection() {
    const books = this.props.suggestedBooks || []

    return (
      <section className="dashboardReadingSection">
        <div className="dashboardReadingSection__wave" aria-hidden="true" />
        <header className="dashboardReadingSection__header">
          <div className="dashboardReadingSection__headerInner">
            <div className="dashboardReadingSection__titleRow">
              <span className="dashboardReadingSection__iconCircle" aria-hidden="true">
                <Icon name="book-open" size={22} color={primitives.blue['600']} />
              </span>
              <div className="dashboardReadingSection__headingCopy">
                <h2 className="dashboardReadingSection__title">Practice Reading</h2>
                <p className="dashboardReadingSection__subtitle">
                  Book recommendations from Lexody members
                </p>
              </div>
            </div>
            {this.props.readingAccentImage && (
              <div className="dashboardReadingSection__illustration">
                <img
                  src={this.props.readingAccentImage}
                  alt=""
                  className="dashboardReadingSection__accentImage"
                />
              </div>
            )}
          </div>
        </header>

        {books.length > 0 ? (
          <div className="dashboardReadingSection__scroll">
            {this.renderSuggestedBooks()}
            <a
              className="dashboardReadingSection__seeAllCard"
              href="/language_resources/books"
            >
              <span className="dashboardReadingSection__seeAllIcon" aria-hidden="true">
                <Icon name="arrow-right" size={22} color={primitives.blue['600']} />
              </span>
              <span className="dashboardReadingSection__seeAllText">Search all books</span>
            </a>
          </div>
        ) : (
          <div className="dashboardReadingSection__empty">
            <p className="dashboardReadingSection__emptyText">
              No book suggestions yet. Be the first to recommend one!
            </p>
            <a
              className="dashboardReadingSection__emptyLink"
              href="/language_resources/books"
            >
              Search Books
              <Icon name="arrow-right" size={16} color={primitives.blue['600']} />
            </a>
          </div>
        )}
      </section>
    )
  }

  renderBlogSection() {
    const posts = this.props.blogPosts || []

    return (
      <section className="dashboardBlogSection">
        <div className="dashboardBlogSection__wave" aria-hidden="true" />
        <header className="dashboardBlogSection__header">
          <div className="dashboardBlogSection__headerInner">
            <div className="dashboardBlogSection__titleRow">
              <span className="dashboardBlogSection__iconCircle" aria-hidden="true">
                <Icon name="book-open" size={22} color={primitives.orange['600']} />
              </span>
              <div className="dashboardBlogSection__headingCopy">
                <h2 className="dashboardBlogSection__title">On the Blog</h2>
                <p className="dashboardBlogSection__subtitle">
                  Tips, guides, and language hacks
                </p>
              </div>
            </div>
            {this.props.blogAccentImage && (
              <img
                src={this.props.blogAccentImage}
                alt=""
                className="dashboardBlogSection__accentImage"
              />
            )}
          </div>
        </header>

        {posts.length > 0 ? (
          <div className="dashboardBlogSection__scroll">
            {this.renderBlogPosts()}
            <a
              className="dashboardBlogSection__seeAllCard"
              href="/blog"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="dashboardBlogSection__seeAllIcon" aria-hidden="true">
                <Icon name="arrow-right" size={22} color={primitives.orange['600']} />
              </span>
              <span className="dashboardBlogSection__seeAllText">See all posts</span>
            </a>
          </div>
        ) : (
          <div className="dashboardBlogSection__empty">
            <p className="dashboardBlogSection__emptyText">New posts are on the way. Check back soon.</p>
            <a
              className="dashboardBlogSection__emptyLink"
              href="/blog"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit the blog
              <Icon name="arrow-right" size={16} color={primitives.orange['600']} />
            </a>
          </div>
        )}
      </section>
    )
  }

  render() {
    return(
      <div className="moreToDoSection">
        <header className="moreToDoSection__intro">
          <h2 className="moreToDoSection__title">More ways to practice</h2>
          <p className="moreToDoSection__subtitle">
            Fluency requires immersion. More ways to immerse and practice any language!
          </p>
        </header>
        {/* {this.renderReadingSection()} */}
        {/* <div className="whiteStandardContainer" style={{marginTop: 30}}>
          <h2 className="modalHeader">Practice Writing</h2>
          <div style={{display: 'flex', flexDirection: (this.props.width < 400 ? 'column' : 'row')}}>
            <div style={{textAlign: 'center'}}>
              <img style={{width: 150}} src={this.props.writingIcon} />
            </div>
            <div style={{paddingLeft: this.props.width < 400 ? 0 : 20}}>
              <h3 className="sectionText">Let’s face it... *you* are the best thing to talk about! Each week, a new writing prompt is available. Try responding in every language you know. Your answers will be posted on your profile!</h3>
              <button onClick={() => window.location.assign("/writing_practice")} className="small_button_secondary" style={{float: 'right', marginTop: 20}}>See this week’s writing prompt</button>
            </div>
          </div>
        </div> */}
        {this.renderBlogSection()}
      </div>
    )
  }
}

export default DashMoreToDoSection;
